import { useState } from "react";
import "./Product.css";
import Hamburger from "../../Hamburger";
import SideNavbar from "../../SideNavbar";
import { Link, useParams, useLocation } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";
import { isAutheticated, signout } from "../../Auth";
import ProductItem from "./ProductItem";
import Bundle from "./Bundle.js";

const Product = () => {
  const [hamburgerOpen, setHamburgerOpen] = useState(false);
  const toggleHamburger = () => setHamburgerOpen(!hamburgerOpen);

  const [loading, setLoading] = useState(true);
  const [childPersonalData, setChildPersonalData] = useState([]);
  const [group, setGroup] = useState([]);
  const [childData, setChildData] = useState([]);
  const [schoolName, setSchoolName] = useState();
  const [suggestions, setSuggestions] = useState([]);
  const [allCartItems] = useState([]);
  const [, setSuccess] = useState(false);

  const child_id = useParams().id;
  const token = isAutheticated();

  // ── Read params passed from SelectChild ──
  const { state } = useLocation();
  const grade_Id = state?.grade_Id || null;
  const gender = state?.gender || null;


  // true  → store mode  (3 dropdowns were selected, no child)
  // false → normal mode (child was selected)
  const isStore = !!(grade_Id && gender);
  const [schoolType, setSchoolType] = useState("");

  useEffect(() => {
    const fetchSchool = async () => {
      try {
        const schoolId = localStorage.getItem("schoolID");
        const resp = await axios.get(`/api/client/school/${schoolId}`);

        console.log("The result is ", resp);

        setSchoolType(resp.data.data.type);
      } catch (err) {
        console.error(err);
      }
    };

    fetchSchool();
  }, []);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        setLoading(true);

        if (isStore) {
          // ── Store mode: call v3 with query params ──
          const res = await axios.get(`/api/client/school/products/v3/`, {
            params: { grade_Id, gender },
            headers: { Authorization: `Bearer ${token}` },
          });

          setSchoolName(res.data.school_name);
          setChildData(res.data.data);
          setGroup(res.data);
        } else {
          // ── Normal mode: fetch child details + v2 products ──
          const [childRes, productRes] = await Promise.all([
            axios.get(`/api/client/child/populated/${child_id}`, {
              headers: { Authorization: `Bearer ${token}` },
            }),
            axios.get(`/api/client/school/products/v2/${child_id}`, {
              headers: { Authorization: `Bearer ${token}` },
            }),
          ]);

          setChildPersonalData(childRes.data.data);
          setSuggestions(childRes.data?.suggestion || []);
          setSchoolName(productRes.data.school_name);
          setChildData(productRes.data.data);
          setGroup(productRes.data);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchAll();
  }, [child_id, token, isStore, gender, grade_Id]);

  return (
    <>
      <div className="product">
        {localStorage.getItem("schoolBanner") && (
          <img
            src={`${localStorage.getItem("schoolBanner")}`}
            alt=""
            width="100%"
            height="100%"
          />
        )}
      </div>

      <div className="mainproducts" style={{ minHeight: "100vh" }}>
        {/* ── Sidebar ── */}
        <div className="Productmenu">
          <div className="submain mt-4 ms-2">
            <Link
              to="/dashboard"
              style={{
                textDecoration: "none",
                color: "black",
                fontSize: "1.7rem",
              }}
            >
              Dashboard
            </Link>
            <p className="mt-3">
              <Link
                to="/select_child"
                style={{
                  textDecoration: "none",
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  color: "blue",
                }}
              >
                Products
              </Link>
            </p>
            <p>
              <Link
                to="/order/history"
                style={{ textDecoration: "none", color: "black" }}
              >
                Order History
              </Link>
            </p>
            {schoolType !== "store" && (
              <p>
                <Link
                  to="/child/add"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  Children
                </Link>
              </p>
            )}
            <p>
              <Link
                to="/support_system"
                style={{ textDecoration: "none", color: "black" }}
              >
                Support
              </Link>
            </p>
            <p className="mt-3">
              <Link
                to="/profile"
                style={{ textDecoration: "none", color: "black" }}
              >
                My Profile
              </Link>
            </p>
            <p onClick={() => signout()}>
              <Link style={{ textDecoration: "none", color: "black" }}>
                Logout
              </Link>
            </p>
          </div>
        </div>

        <div className="hamburger" onClick={toggleHamburger}>
          <Hamburger isOpen={hamburgerOpen} />
        </div>

        <SideNavbar hamburgerOpen={hamburgerOpen} />

        <div className="cardContentss pb-5">
          {/* ── Child details — hidden in store mode ── */}
          {!isStore && (
            <>
              <div
                className="d-flex justify-content-center pt-3"
                style={{
                  fontFamily: "Roboto",
                  fontWeight: "500",
                  fontSize: "48px",
                  lineHeight: "56px",
                }}
              >
                {childPersonalData?.name}
              </div>

              <div className="d-flex justify-content-center mt-0">
                <strong>
                  {childPersonalData?.gender} , {childPersonalData?.grade?.name}{" "}
                  , {childPersonalData?.house?.name}
                </strong>
              </div>
            </>
          )}

          {/* ── School name — always shown ── */}
          {schoolName && (
            <h5 className="d-flex justify-content-center mt-3 font-italic">
              [ {schoolName} ]
            </h5>
          )}

          {/* ── Suggestions — hidden in store mode ── */}
          {!isStore && suggestions?.length > 0 && (
            <div>
              <div style={{ maxWidth: "500px" }} className="mx-auto">
                <p className="form-label fw-bold text-center">Suggestions</p>
                <table className="table table-bordered table-sm table-success text-center">
                  <thead>
                    <tr>
                      <th>Uniform</th>
                      <th>Size</th>
                    </tr>
                  </thead>
                  <tbody>
                    {suggestions.map((u, idx) => (
                      <tr key={idx}>
                        <td>{u?.uniform}</td>
                        <td>{u?.size}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* ── Products ── */}
          {childData && childData.length > 0 ? (
            <>
              {childData.map((item, index) => (
                <div key={index}>
                  <h2 className="d-flex justify-content-center mt-3">
                    {item.name}
                  </h2>

                  {group.option === "bundle" ? (
                    <Bundle
                      products={item.products}
                      option_id={item._id}
                      childId={childPersonalData._id}
                      suggestions={suggestions}
                    />
                  ) : (
                    <>
                      {item.products.map((item2, index) => (
                        <ProductItem
                          key={index}
                          item_data={item2}
                          option={group.option}
                          option_id={item._id}
                          WishlistItems={[]}
                          childId={childPersonalData._id}
                          setSuccess={setSuccess}
                          allCartItems={allCartItems}
                          suggestions={suggestions}
                        />
                      ))}
                    </>
                  )}
                </div>
              ))}
            </>
          ) : loading ? (
            <div className="text-center mt-5">
              <div className="spinner-grow" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div style={{ width: "100%", height: "8rem" }} className="w-100">
              <h2
                style={{ marginTop: "5rem" }}
                className="d-flex justify-content-center"
              >
                No products found.
              </h2>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Product;
